module.exports = "float PI2_INV = 0.1591549431;"